import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_kpa6dHjrPsvW: {
	id: 'prd_kpa6d2DEV2HjrPsvW'
	ident: 'prd_kpa6dHjrPsvW'
	sku: 'simple_premium_1m_7_99_1m_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'month'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_Vce0r2DEV2wAZ7Rvw'
			amount: 44
			amount_usd: 7.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 7.99
			discount: 36.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'month'
			interval_duration: 1
			iteration_count: null
			price_id: 'prc_7VYH32DEV2w1zdVMV'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_kpa6dHjrPsvW, SubscriptionProduct>
const prd_kpa6dHjrPsvW = { ident: 'prd_kpa6dHjrPsvW' } as typeof _prd_kpa6dHjrPsvW

export default prd_kpa6dHjrPsvW
